'use client;';

import { createContext, useContext, useMemo } from 'react';

import { ApiSchemas, useApiV1Ctx } from '@/components/providers/v1-api';

export type ServiceTypeTemplate = ApiSchemas['ServiceTypeTemplateRead'];

interface ContextType {
  serviceTypeTemplates: ServiceTypeTemplate[];
  serviceTypeTemplatesById: Map<string, ServiceTypeTemplate>;
  isLoading: boolean;
}

const ServiceTypeTemplatesContext = createContext<ContextType | null>(null);

export function useServiceTypeTemplatesCtx() {
  const ctx = useContext(ServiceTypeTemplatesContext);
  if (!ctx) {
    throw new Error('useServiceTypeTemplatesCtx must be used within a ServiceTypeTemplatesProvider');
  }
  return ctx;
}

interface Props {
  children: React.ReactNode;
}

export function ServiceTypeTemplatesProvider({ children }: Props) {
  const { api } = useApiV1Ctx();
  const { data: serviceTypeTemplates = [], isLoading } =
    api.serviceTypeTemplates.getAllServiceTypeTemplatesGet.useQuery(undefined, {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    });

  const serviceTypeTemplatesById = useMemo(() => {
    return new Map(serviceTypeTemplates.map((serviceTemplate) => [serviceTemplate.id, serviceTemplate]));
  }, [serviceTypeTemplates]);

  return (
    <ServiceTypeTemplatesContext.Provider value={{ serviceTypeTemplates, serviceTypeTemplatesById, isLoading }}>
      {children}
    </ServiceTypeTemplatesContext.Provider>
  );
}
